import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { LANGUAGES } from "@/lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("acas_lang", code); } catch (e) {}
  };

  return (
    <Select value={current} onValueChange={change}>
      <SelectTrigger
        className={variant === "compact" ? "h-8 w-[120px] text-xs" : "h-9 w-[150px]"}
        data-testid="language-switcher"
      >
        <span className="flex items-center gap-1.5">
          <Languages className="h-3.5 w-3.5 text-muted-foreground" />
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-${l.code}`}>
            <span className="flex items-center gap-2">
              <span className="font-medium">{l.native}</span>
              <span className="text-[10px] text-muted-foreground">{l.label}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
